import { Directive, Input, HostListener } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

// tslint:disable-next-line: directive-selector
@Directive({ selector: '[copy-clipboard]' })
export class CopyClipboardDirective {

    constructor(private toastr: ToastrService) { }

    @Input('copy-clipboard')
    public content: string;

    @Input('contentName')
    public contentName: string;

    @HostListener('click', ['$event'])
    public onClick(event: MouseEvent): void {
        event.preventDefault();
        if (!this.content) {
            return;
        }

        let listener = (e: ClipboardEvent) => {
            const clipboard  = e.clipboardData;
            clipboard.setData('text', this.content.toString());
            e.preventDefault();
        }

        document.addEventListener("copy", listener, false)
        document.execCommand("copy");
        document.removeEventListener("copy", listener, false);

        this.toastr.warning(`${this.contentName} copiado com sucesso!`);

    }
}